import React from 'react'
import { useSelector } from 'react-redux'

import type { CheckboxListFilterProps } from '~/components/common/filters/CheckboxListFilter'
import { getFilters as getOnHandFilters } from '~/store/duck/onHandCatalog'

import CategoryFilter from '../filters/CategoryFilter'

export interface OnHandCategoryFilterProps extends CheckboxListFilterProps {}

const OnHandCategoryFilter = (props: OnHandCategoryFilterProps) => {
  const onHandFilters = useSelector(getOnHandFilters)

  return (
    <CategoryFilter
      selectedCategoryFilter={onHandFilters?.categoryIds}
      {...props}
    />
  )
}

export default OnHandCategoryFilter
